import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  ControlLabel,
  FormControl,
  FormGroup,
} from 'react-bootstrap';
import _ from 'underscore';
import moment from 'moment';

export default class AccessorialMetaInput extends Component {
  static propTypes = {
    accessorial: PropTypes.object,
    requireApproval: PropTypes.bool,
    metaKey: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    addAccessorial: PropTypes.func.isRequired,
    load: PropTypes.shape({
      pallets: PropTypes.arrayOf(PropTypes.shape({
        quantity: PropTypes.number.isRequired,
      })),
      weight: PropTypes.number,
    }),
  };


  static defaultProps = {
    requireApproval: false,
    load: {
      weight: 0,
      pallets: [],
    },
  };
  constructor(props) {
    super(props);
    this.state = {
      wait_start_timestamp: null,
      wait_end_timestamp: null,
      wait_total_time: null,
      metaValue: this.calculateInitialValue(props.metaKey),
    };
  }

  calculateInitialValue(key) {
    let initialValue = '';

    const {
      load: {
        pallets,
        weight,
      },
    } = this.props;

    if (key === 'pallets') {
      initialValue = pallets.length !== 0
        ? pallets[0].quantity
        : '';
    }
    if (key === 'duration') {
      initialValue = 30;
    }
    if (key === 'weight') {
      initialValue = weight >= 500 ? weight : 500;
    }
    return initialValue;
  }

  renderApprovalInput() {
    if (this.props.requireApproval) {
      return (
        <FormGroup>
          <ControlLabel>Approval Code</ControlLabel>
          <FormControl
            type="text"
            placeholder="ACXLU12345"
            onChange={(e) => {
              this.props.onChange('approvalCode')(e.target.value);
            }}
          />
        </FormGroup>
      );
    }
    return null;
  }

  calculateTotalTime(start, end) {
    if(start && end){
      let totalTime = end.diff(start, 'minutes');
      return totalTime
    }
    return null
  }

  processWaitTime(time, isStart){
    if(!time){
      return
    }
    const timeAndDate = moment(time)
    if(!timeAndDate.isValid()){
      return
    }
    if(isStart){
      let totalTime = this.calculateTotalTime(timeAndDate, this.state.wait_end_timestamp)
      this.setState({
        wait_start_timestamp: timeAndDate,
        wait_start_description: moment(time).format('lll'),
        wait_total_time: totalTime
      })
    }else{
      let totalTime = this.calculateTotalTime(this.state.wait_start_timestamp, timeAndDate)
      this.setState({
        wait_end_timestamp: timeAndDate,
        wait_end_description: moment(time).format('lll'),
        wait_total_time: totalTime
      })
    }
  }

  isValidTimePeriod(){
    const { wait_start_timestamp, wait_end_timestamp, wait_total_time } = this.state;
    return wait_start_timestamp  && wait_end_timestamp  && wait_total_time && wait_total_time >= 0 && wait_total_time < 1441 //Wait time cannot span more than a 24 hour period
  }

  renderAccessorialMetaInput(accessorial) {

    let that = this;
    const inputItems = _.map(accessorial.meta_data, function(value, key){
      if(value.wait_enabled){
        return (<div key={key}>
          <FormGroup>
            <ControlLabel>Wait Time Start</ControlLabel>
            <FormControl
              label={value.label}
              type="datetime-local"
              onChange={(e) => {
                that.processWaitTime(e.target.value, true);
              }}
            />
            <ControlLabel>Wait Time End</ControlLabel>
            <FormControl
              label={value.label}
              type="datetime-local"
              onChange={(e) => {
                that.processWaitTime(e.target.value, false);
              }}
            />
            <div className="flex justify-end">
              <button disabled={!that.isValidTimePeriod()} className="button button-green my-2" onClick={() => that.props.addAccessorial(that.state.wait_total_time, "Wait time started " + that.state.wait_start_description + "\n" + " Wait time ended " + that.state.wait_end_description)}>Save</button>
            </div>
          </FormGroup>
        </div>)
      }else{
        return(<div key={key}>
          <FormGroup>
            <ControlLabel>{value.label}</ControlLabel>
            <FormControl
              label={value.label}
              type="number"
              step="1"
              min={value.min || 1}
              defaultValue={that.state.metaValue}
              onChange={(e) => {
                that.setState({ metaValue: e.target.value });
              }}
            />
            <div className="flex justify-end">
              <button className="button button-green my-2" onClick={() => that.props.addAccessorial(that.state.metaValue)}>Save</button>
            </div>
          </FormGroup>
        </div>)
      }}
    )
    return (
      <div>
        {inputItems}
        {this.renderApprovalInput()}
      </div>
    );
  }

  render() {
    const { accessorial } = this.props;
    return (
      <div>
        {this.renderAccessorialMetaInput(accessorial)}
      </div>
    );
  }
}
